module.exports = __webpack_public_path__ + "static/img/ma2.1780697.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma2.gif
// module id = KjSi
// module chunks = 1